import { useState } from 'react';
import { Form, Input, Button, Row, Col, message } from 'antd';
import { api } from '../api';

export default function ContactForm({ contact, onSaved }) {
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const handleSave = async (values) => {
    setSaving(true);
    try {
      await api.contacts.update(contact.id, values);
      message.success('Kontakt gespeichert');
      onSaved?.();
    } catch (err) {
      message.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Form form={form} layout="vertical" initialValues={contact} onFinish={handleSave}>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item name="first_name" label="Vorname">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="last_name" label="Nachname">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="company" label="Firma">
        <Input />
      </Form.Item>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item name="phone" label="Telefon">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="email" label="E-Mail">
            <Input type="email" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item name="ust_id" label="USt-IdNr.">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="hr_nr" label="HRB-Nr.">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item style={{ marginBottom: 0 }}>
        <Button type="primary" htmlType="submit" loading={saving}>Speichern</Button>
      </Form.Item>
    </Form>
  );
}
